/**
 * This is a very anti-SPA function. It will reload the entire page.
 * Consider better ways to reset the application state or re-run effects.
 * @returns {void}
 */
export function reloadFullPage() {
  return window.location.reload();
}
